import { g as r } from "../internals/global.js";
import { f as t } from "../internals/function-call.js";
import { a as n } from "../internals/array-buffer-view-core.js";
import { l as a } from "../internals/length-of-array-like.js";
import { t as e } from "../internals/to-offset.js";
import { t as o } from "../internals/to-object.js";
import { f as s } from "../internals/fails.js";
var i = r.RangeError,
  f = r.Int8Array,
  l = f && f.prototype,
  m = l && l.set,
  p = n.aTypedArray,
  h = n.exportTypedArrayMethod,
  g = !s(function () {
    var r = new Uint8ClampedArray(2);
    return t(m, r, {
      length: 1,
      0: 3
    }, 1), 3 !== r[1];
  }),
  y = g && n.NATIVE_ARRAY_BUFFER_VIEWS && s(function () {
    var r = new f(2);
    return r.set(1), r.set("2", 1), 0 !== r[0] || 2 !== r[1];
  });
h("set", function (r) {
  p(this);
  var n = e(arguments.length > 1 ? arguments[1] : void 0, 1),
    s = o(r);
  if (g) return t(m, this, s, n);
  var f = this.length,
    l = a(s),
    h = 0;
  if (l + n > f) throw i("Wrong length");
  for (; h < l;) this[n + h] = s[h++];
}, !g || y);